import { defineMessages } from 'react-intl';

export default defineMessages({
    billed: {
        id: 'PremiumAuditTable.billed',
        defaultMessage: 'Billed – Audit has been reviewed and has billed in our system. The final audit summary is available on portal',
    },
    cancelled: {
        id: 'PremiumAuditTable.cancelled',
        defaultMessage: 'Cancelled – Audit request was canceled, usually due to reinstatement',
    },
    closeOut: {
        id: 'PremiumAuditTable.closeOut',
        defaultMessage: 'CloseOut – Audit was estimated due to noncompliance',
    },
    complete: {
        id: 'PremiumAuditTable.complete',
        defaultMessage: 'Complete – Audit has been billed but not invoiced',
    },
    invoiced: {
        id: 'PremiumAuditTable.invoiced',
        defaultMessage: 'Invoiced – The invoice with the final audit has been sent out and is available on the portal',
    },
    waived: {
        id: 'PremiumAuditTable.waived',
        defaultMessage: 'Waived – Audit has been closed out on policy estimates',
    },
});